import { QuickNavPage } from "constants/quickNav/types";

export const getCommonQuickNavPages = (appPath: string): QuickNavPage[] => [
  { name: "Chat", path: `${appPath}/chat` },
  { name: "Documents", path: `${appPath}/documents` },
];
